import { API } from '@/modules/api-service/api-service';
import type { Core, Data } from '@strapi/types';

const url = '/project-files';

export const getProjectFiles = async ({
	projectId,
	documentType,
	documentName,
	startDate,
	endDate,
}: Core.Helpers.Controllers.GetRequestBody<'api::project-file.project-file', 'getProjectFiles'>) => {
	const { data: response } = await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::project-file.project-file', 'getProjectFiles'>,
		Core.Helpers.Controllers.GetRequestBody<'api::project-file.project-file', 'getProjectFiles'>
	>(url, { projectId, documentType, documentName, startDate, endDate });

	return response;
};

export const downloadProjectAttachmentApi = async (
	projectFileId: Pick<Data.Entity<'api::project-file.project-file'>, 'documentId'>['documentId'],
) => {
	return await API().get<Core.Helpers.Services.GetReturnType<'api::project-file.project-file', 'getDownloadUrl'>>(
		`${url}/download/${projectFileId}`,
	);
};

export const uploadProjectAttachmentApi = async ({
	projectId,
	body,
}: {
	projectId: Pick<Data.Entity<'api::project.project'>, 'documentId'>['documentId'];
	body: FormData;
}) => {
	return await API().post(`${url}/project/${projectId}`, body);
};

export const deleteProjectAttachmentApi = async ({
	documentId,
}: {
	documentId: Pick<Data.Entity<'api::project-file.project-file'>, 'documentId'>['documentId'];
}) => {
	return await API().delete(`${url}/${documentId}`);
};

export const downloadBomApi = async ({
	documentId,
	type,
}: {
	documentId: Pick<Data.Entity<'api::project-file.project-file'>, 'documentId'>['documentId'];
	type: 'xlsx' | 'pdc';
}) => {
	const contentType = {
		xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		pdc: 'text/csv',
	}[type];
	const response = await API().get<Core.Helpers.Services.GetReturnType<'api::project-file.project-file', 'downloadBom'>>(
		`${url}/bom/${type}/${documentId}`,
		{
			headers: {
				'Content-Type': contentType,
				'X-Strapi-Request': 'true',
			},
		},
	);

	return response;
};
